import {parseCookies} from 'nookies'
import {useEffect, useState} from 'react'

export const useInputsCookie = () => {
  const [input, setInput] = useState('')

  useEffect(() => {
    const {presentInputs} = parseCookies()
    if (!presentInputs) return

    const val = JSON.parse(presentInputs)?.input
    if (!val) return

    setInput(val.replace(/["]+/g, ''))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return input
}
